<template>
  <div class="rb-price">{{ priceMessage }}</div>
</template>
<script>
/**
 * Displays total setting price
 *
 * @implements
 * FormattersMixin
 * CommMixin
 * PriceMixin
 *
 * @props
 * prev: String
 * prevComplete: String
 *
 * @listens
 * rb-update-price
 *
 * @emits
 * rb-total-price-update
 *
 */
import FormattersMixin from "@/mixins/FormattersMixin";
import PriceMixin from "@/mixins/PriceMixin";
import CommMixin from "@/mixins/CommMixin";
import { formatMoney } from "../lib";
export default {
  mixins: [FormattersMixin, CommMixin, PriceMixin],
  props: {
    messagePrev: {
      type: String,
      default: "",
    },
    messagePost: {
      type: String,
      default: "",
    },
    messagePrevComplete: {
      type: String,
      default: "",
    },
    combinePrice: {
      type: Boolean,
      default: false,
    },
  },

  computed: {
    priceMessage: function () {
      if (this.combinePrice) {
        return `${this.prevMessage} $${formatMoney(this.totalPrice)}`;
      } else {
        if (this.diamondPrice) {
          return `${this.prevMessage} $${formatMoney(this.totalPrice)}`;
        } else {
          return `$${formatMoney(this.baseRingPrice)} ${this.messagePost}`;
        }
      }
    },
    prevMessage: function () {
      //return this.prev;
      // Uncomment this to re-enable the "from" model that disappears when diamond is selected
      return this.diamondPrice
        ? this.messagePrevComplete !== ""
          ? this.messagePrevComplete
          : ""
        : `${this.messagePrev} `;
    },
  },
};
</script>
